import { FC } from 'react';
import cls from './table-pagination.module.scss';
import IconButton from 'shared/ui/iconButton/icon-button';
import { ICONS } from 'shared/constants/images';
import { useTranslation } from 'hooks/api/useTranslation';
import { TablePaginationProps } from './table.types';

export const TablePagination: FC<TablePaginationProps> = ({
  page,
  pageSize,
  total,
  onPageChange,
}) => {
  const { t } = useTranslation();
  const pageCount = Math.max(1, Math.ceil(total / pageSize));

  if (pageCount <= 1) {
    return null;
  }

  const currentPage = Math.min(Math.max(1, page), pageCount);
  const rangeStart = total === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const rangeEnd = Math.min(currentPage * pageSize, total);

  return (
    <div className={cls.pagination}>
      <span className={cls.range}>
        {t('tablePaginationRange', '_global', '', {
          from: rangeStart,
          to: rangeEnd,
          total,
        })}
      </span>
      <div className={cls.pageNav}>
        <IconButton
          dense
          pathToIcon={ICONS.chevronLeft}
          disabled={currentPage <= 1}
          aria-label={t('tablePaginationPrevious')}
          onClick={() => onPageChange(currentPage - 1)}
        />
        <IconButton
          dense
          pathToIcon={ICONS.chevronRight}
          disabled={currentPage >= pageCount}
          aria-label={t('tablePaginationNext')}
          onClick={() => onPageChange(currentPage + 1)}
        />
      </div>
    </div>
  );
};
